import { Directive, ElementRef } from "@angular/core";

@Directive({
  selector: "[tooltip-content]",
})
export class TooltipContentDirective {
  constructor(public elementRef: ElementRef) {}
}
